// relativeAge — pure helper: ISO timestamp → compact "age" string for The Wire
// byline (spec 2026-08-09-news-feed.md §PR 3). Single job: format one timestamp.
//
// Buckets: <60s -> "now", <60m -> "{m}m", <24h -> "{h}h", else "{d}d". A future
// timestamp (clock skew between device and server) fails closed to "now" rather
// than rendering a negative age. Null / non-string / unparseable input -> "" so
// the byline degrades to just the league label (no dangling separator).
export function relativeAge(publishedAt) {
  if (!publishedAt) return "";
  const t = new Date(publishedAt).getTime();
  if (isNaN(t)) return "";

  const diffMs = Date.now() - t;
  if (diffMs < 60 * 1000) return "now"; // also covers small negative (future) skew

  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(hours / 24);
  return `${days}d`;
}
